<template>
  <v-form @submit.prevent="onSubmit">
    <row-form :doc="doc" :headers="headers" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
    <slot></slot>
  </v-form>
</template>

<script>
// @ is an alias to /src
import RowForm from "@/views/user/exercises/timeline/RowForm";

export default {
  name: "RowEdit",
  components: {
    RowForm,
  },
  props: {
    id: String,
    doc: {
      type: Object,
      default: () => {},
    },
    headers: Array,
  },
  methods: {
    onSubmit() {
      this.$emit("editNoteCommit", this.doc);
    },
  },
};
</script>
